import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import MyPage from './views/MyPage.vue'
import Groups from './views/Groups.vue'
import Group from './views/Group.vue'
import Games from './views/Games.vue'
import Welcome from './views/Welcome.vue'
import Farewell from './views/Farewell.vue'
import EditProfile from './views/EditProfile.vue'
import Signout from './views/Signout.vue'
import PassOn from './views/PassOn.vue'
import firebase from 'firebase/app';
import 'firebase/auth';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome,
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      // meta: {
      //   requiresAuth: true
      // }
    },
    {
      path: '/my-page',
      name: 'MyPage',
      component: MyPage
    },
    {
      path: '/groups',
      name: 'Groups',
      component: Groups
    },
    {
      path: '/group/:group_id',
      name: 'Group',
      component: Group
    },
    {
      path: '/group-games/:group_id',
      name: 'Games',
      component: Games
    },
    {
      path: '/farewell/',
      name: 'Farewell',
      component: Farewell
    },
    {
      path: '/edit-profile/',
      name: 'EditProfile',
      component: EditProfile
    },
    {
      path: '/signout/:group_id',
      name: 'Signout',
      component: Signout
    },
    {
      path: '/pass-on',
      name: 'PassOn',
      component: PassOn
    }
  ]
})

router.beforeEach((to, from, next) => {
  // check to see if route requires auth
  if(to.matched.some(rec => rec.meta.requiresAuth)){
    let user = firebase.auth().currentUser;
    if(user){
      // user signed in, proceed to route
      next()
    } else {
      // no user signed in, redirect to login
      // next({ name: 'Welcome' })
      next()
    }
  } else {
    next()
  }
})

export default router;